// 子仓库-标签导航

export default {
  namespaced: true,
  state: () => ({
    visitedViews: [], //标签导航集合
    cacheRouteNames: [], //缓存路由的名字集合
  }),
  getters: {},
  mutations: {
    // 添加标签导航
    addView(state, view){
      this.commit('tagsView/addCacheRouteName', view);  //添加路由缓存
      
      // 当前添加的视图是否已经存储过，存储过则不再添加
      const isExits = state.visitedViews.some(v => v.path === view.path);
      if (isExits) return;
      const newView = {
        ...view,
      }
      state.visitedViews.push(newView);
    },
    // 删除标签导航
    deleteView(state, view){
      const index = state.visitedViews.findIndex((v) => v.path === view.path);
      if (index > -1) state.visitedViews.splice(index, 1);
      this.commit('tagsView/deleteCacheRouteName', view);  //删除路由缓存
    },
    

    // 添加指定路由缓存
    addCacheRouteName(state, view){
      if (state.cacheRouteNames.includes(view.name)) return;
      if (!view.meta?.noCache) state.cacheRouteNames.push(view.name);
    },
    // 删除指定路由缓存
    deleteCacheRouteName(state, view){
      const index = state.cacheRouteNames.indexOf(view.name);
      if (index > -1) state.cacheRouteNames.splice(index, 1);
    },
    // 清空路由缓存
    clearCacheRouteName(state){
      state.cacheRouteNames = [];
    },


    // 关闭所有标签导航，只留下固定的标签导航
    delAllView(state){
      state.visitedViews = state.visitedViews.filter((tag) => tag.meta.affixTagView);
      state.cacheRouteNames = [];
    },
    // 关闭其它标签导航，只留下自己和固定的标签导航
    delOthersViews(state, view){
      state.visitedViews = state.visitedViews.filter((tag) => tag.meta.affixTagView || tag.path === view.path);
      state.cacheRouteNames = state.cacheRouteNames.filter(name => name === view.name);
    },
  },
  actions: {},
  modules: {},
};
